import {
  useAutocompleteSource,
  ApiFilterOperation,
  abortableFetch,
} from '@eas/common-web';
import { UFormGovServiceAutocomplete } from '../../models';
import { EvidenceAPI } from '../../enums';

export function useUFormGovServiceAutocomplete(agendaId?: string) {
  const params = agendaId
    ? {
        filters: [
          {
            operation: ApiFilterOperation.EQ,
            field: 'agenda.id',
            value: agendaId,
          },
        ],
      }
    : {};

  return useAutocompleteSource<UFormGovServiceAutocomplete>({
    url: `${EvidenceAPI.UFORM_GOV_SERVICE}/autocomplete`,
    params,
  });
}

export function getServiceById(id: string) {
  return abortableFetch(`${EvidenceAPI.UFORM_GOV_SERVICE}/${id}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    method: 'GET',
  });
}

export function getServicesByAgendaId(agendaId: string) {
  return abortableFetch(`${EvidenceAPI.UFORM_GOV_SERVICE}/autocomplete`, {
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    method: 'POST',
    body: JSON.stringify({
      filters: [
        {
          operation: ApiFilterOperation.EQ,
          field: 'agenda.id',
          value: agendaId,
        },
      ],
      size: 2,
    }),
  });
}
